import { render, staticRenderFns } from "./LifeRemaker.vue?vue&type=template&id=42c839b0&scoped=true&"
import script from "./LifeRemaker.vue?vue&type=script&lang=js&"
export * from "./LifeRemaker.vue?vue&type=script&lang=js&"
import style0 from "./LifeRemaker.vue?vue&type=style&index=0&id=42c839b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c839b0",
  null
  
)

export default component.exports